import React from 'react';
import Layout from '@/common/Layout';
import SievePublicPage from './components/SievePublicPage';

const SievePublic = () => {
  return (
    <Layout sider={false} menuItems={false}>
      <SievePublicPage />
    </Layout>
  );
};

export default SievePublic;
